import React from 'react';
interface PiggyBankProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
}
const sizeMap = {
  sm: {
    w: 120,
    h: 100
  },
  md: {
    w: 180,
    h: 150
  },
  lg: {
    w: 260,
    h: 216
  },
  xl: {
    w: 340,
    h: 283
  }
};
export function PiggyBank({
  size = 'lg'
}: PiggyBankProps) {
  const dim = sizeMap[size];
  return <div className="relative inline-flex flex-col items-center" role="img" aria-label="Alcancía con moneda cayendo" data-id="element-134">
      {/* Coin dropping — pure CSS animation */}
      <div className="absolute z-10 animate-coin-drop" style={{
      top: -8,
      left: '50%',
      marginLeft: -8,
      '--drop-distance': `${dim.h * 0.32}px`
    } as React.CSSProperties} data-id="element-135">
        <svg width="16" height="16" viewBox="0 0 16 16" data-id="element-136">
          <circle cx="8" cy="8" r="7" fill="#F5C842" stroke="#D4920B" strokeWidth="1.5" data-id="element-137" />
          <text x="8" y="11.5" textAnchor="middle" fill="#D4920B" fontSize="9" fontWeight="bold" data-id="element-138">
            $
          </text>
        </svg>
      </div>

      {/* Piggy bank SVG — pure CSS bounce */}
      <svg className="animate-piggy-bounce" width={dim.w} height={dim.h} viewBox="0 0 260 216" fill="none" data-id="element-139">
        <ellipse cx="130" cy="206" rx="80" ry="8" fill="rgba(0,0,0,0.2)" data-id="element-140" />
        <ellipse cx="88" cy="52" rx="18" ry="24" fill="#DB7093" transform="rotate(-15 88 52)" data-id="element-141" />
        <ellipse cx="88" cy="52" rx="11" ry="16" fill="#F0A0B8" transform="rotate(-15 88 52)" data-id="element-142" />
        <ellipse cx="135" cy="120" rx="95" ry="75" fill="#F472B6" data-id="element-143" />
        <ellipse cx="115" cy="100" rx="55" ry="40" fill="#F9A8D4" opacity="0.4" data-id="element-144" />
        <ellipse cx="140" cy="155" rx="70" ry="30" fill="#DB2777" opacity="0.15" data-id="element-145" />
        <rect x="118" y="42" width="30" height="5" rx="2.5" fill="#BE185D" data-id="element-146" />
        <rect x="120" y="43" width="26" height="3" rx="1.5" fill="#831843" data-id="element-147" />
        <ellipse cx="168" cy="52" rx="18" ry="24" fill="#F472B6" transform="rotate(15 168 52)" data-id="element-148" />
        <ellipse cx="168" cy="52" rx="11" ry="16" fill="#F9A8D4" transform="rotate(15 168 52)" data-id="element-149" />
        <ellipse cx="225" cy="115" rx="28" ry="22" fill="#F9A8D4" data-id="element-150" />
        <ellipse cx="225" cy="115" rx="24" ry="18" fill="#FBB6CE" data-id="element-151" />
        <ellipse cx="219" cy="113" rx="4" ry="5" fill="#DB7093" data-id="element-152" />
        <ellipse cx="231" cy="113" rx="4" ry="5" fill="#DB7093" data-id="element-153" />
        <circle cx="190" cy="82" r="8" fill="white" data-id="element-154" />
        <circle cx="192" cy="81" r="5" fill="#1C1917" data-id="element-155" />
        <circle cx="194" cy="79" r="2" fill="white" data-id="element-156" />
        <ellipse cx="200" cy="105" rx="12" ry="8" fill="#F9A8D4" opacity="0.6" data-id="element-157" />
        <rect x="80" y="175" width="22" height="24" rx="8" fill="#EC4899" data-id="element-158" />
        <rect x="115" y="178" width="22" height="21" rx="8" fill="#EC4899" data-id="element-159" />
        <rect x="150" y="178" width="22" height="21" rx="8" fill="#EC4899" data-id="element-160" />
        <rect x="185" y="175" width="22" height="24" rx="8" fill="#EC4899" data-id="element-161" />
        <rect x="78" y="193" width="26" height="7" rx="3.5" fill="#BE185D" data-id="element-162" />
        <rect x="113" y="193" width="26" height="7" rx="3.5" fill="#BE185D" data-id="element-163" />
        <rect x="148" y="193" width="26" height="7" rx="3.5" fill="#BE185D" data-id="element-164" />
        <rect x="183" y="193" width="26" height="7" rx="3.5" fill="#BE185D" data-id="element-165" />
        <path d="M40 105 C25 95, 20 110, 30 115 C40 120, 35 130, 25 125" stroke="#EC4899" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-166" />
        <text x="130" y="135" textAnchor="middle" fill="#BE185D" fontSize="32" fontWeight="bold" opacity="0.2" data-id="element-167">
          $
        </text>
      </svg>
    </div>;
}